<template>
  <div class="row padd-0">
    <div class="col-12 padd-0">
      <div class="row">
        <div class="col-6">
          <label for="startDate-lab">From</label>
          <b-form-datepicker
            id="startDate"
            :state="wrongCustDate.start"
            v-model="value.startDate"
            @input="checkSelectedDate()"
            class="mb-2"
          ></b-form-datepicker>
        </div>
        <div class="col-6">
          <label for="endDate-lab">To</label>
          <b-form-datepicker
            id="endDate-lab"
            :state="wrongCustDate.end"
            v-model="value.endDate"
            @input="checkSelectedDate()"
            class="mb-2"
          ></b-form-datepicker>
        </div>
      </div>
      <div class="row" v-if="custDateErr != ''">
        <div class="col-12" style="text-align: center; color:darkred;">{{custDateErr}}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "datePickerForm",

  props: {
    value: Object
  },
  data() {
    return {
      wrongCustDate: {
        start: undefined,
        end: undefined
      },
      custDateErr: ""
    };
  },

  computed: {},

  watch: {},

  mounted() {},

  methods: {
    checkSelectedDate() {
      let nw = Date.parse(new Date());
      this.custDateErr = "";

      this.wrongCustDate.start = this.value.startDate !== "" ? true : undefined;
      this.wrongCustDate.end = this.value.endDate !== "" ? true : undefined;

      if (
        this.wrongCustDate.start === true &&
        nw < Date.parse(new Date(`${this.value.startDate}T00:00:01-07:00`))
      ) {
        this.wrongCustDate.start = false;
        this.custDateErr = `Starting date cannot be in future. Please, select another one`;
      }

      if (
        this.wrongCustDate.start != undefined &&
        this.wrongCustDate.end != undefined
      ) {
        let st = Date.parse(new Date(`${this.value.startDate}T00:00:01-07:00`));
        let en = Date.parse(new Date(`${this.value.endDate}T23:59:59-07:00`));

        this.wrongCustDate.start = nw > st && en > st;
        this.wrongCustDate.end = en > st;

        this.custDateErr =
          nw < st
            ? `Starting date cannot be in future. Please, select another one`
            : en < st
            ? `Start-date has to come earlier than end-date`
            : "";
      }

      this.$emit("input", this.value);
      this.$emit(
        "datePickBtnDisable",
        this.wrongCustDate.start === false || this.wrongCustDate.end === false
      );
    }
  }
};
</script>
<style>
.padd-0 {
  padding: 0;
}
</style>